const curatedMap = {
  "intimate hang_standout piece_mirror_bohemian_dark": [
    "rain",
    "fuji",
    "dream",
    "rise",
    "water",
    "ocho",
    "stayone",
    "panton"
  ],
  "intimate hang_standout piece_mirror_bohemian_neutral": [
    "aenf",
    "panton",
    "kyoto",
    "loved",
    "108",
    "bloomlight",
    "bloomdark",
    "wins"
  ],
    "intimate hang_standout piece_mirror_bohemian_simple": [
    "aenf",
    "panton",
    "kyoto",
    "loved",
    "108",
    "bloomlight",
    "bloomdark",
    "wins"
  ],
  "intimate hang_standout piece_mirror_bohemian_bright": [
    "rise",
    "floral",
    "trapped",
    "soul",
    "peace",
    "cogs",
    "loved",
    "bloomlight"
  ],
  "intimate hang_standout piece_mirror_bohemian_hazy": [
    "rise",
    "stayone",
    "trapped",
    "room",
    "remember",
    "over",
    "veil",
    "lies"
  ],
  "intimate hang_standout piece_mirror_eclectic_dark": [
    "trapped",
    "stayone",
    "panton",
    "rain",
    "soul",
    "bloomdark",
    "loved",
    "cool"
  ],
  "intimate hang_standout piece_mirror_eclectic_neutral": [
    "soul",
    "rise",
    "remember",
    "veil",
    "staytwo",
    "loved",
    "bloomlight",
    "floral"
  ],
   "intimate hang_standout piece_mirror_eclectic_simple": [
    "soul",
    "rise",
    "remember",
    "veil",
    "staytwo",
    "loved",
    "bloomlight",
    "floral"
  ],
  "intimate hang_standout piece_mirror_eclectic_bright": [
    "soul",
    "cogs",
    "peace",
    "trapped",
    "lies",
    "radiant",
    "search",
    "envy"
  ],
  "intimate hang_standout piece_mirror_eclectic_hazy": [
    "envy",
    "cogs",
    "rain",
    "club",
    "staytwo",
    "moment",
    "trapped",
    "search"
  ],
  "intimate hang_standout piece_mirror_minimalist_dark": [
    "bloomdark",
    "loved",
    "kyoto",
    "bloomlight",
    "water",
    "moment",
    "aenf",
    "panton"
  ],
  "intimate hang_standout piece_mirror_minimalist_neutral": [
    "bloomdark",
    "loved",
    "rise",
    "bloomlight",
    "moment",
    "wins",
    "108",
    "lately"
  ],
   "intimate hang_standout piece_mirror_minimalist_simple": [
    "bloomdark",
    "loved",
    "rise",
    "bloomlight",
    "moment",
    "wins",
    "108",
    "lately"
  ],
  "intimate hang_standout piece_mirror_minimalist_bright": [
    "rise",
    "loved",
    "dream",
    "soul",
    "load",
    "staytwo",
    "floral",
    "lately"
  ],
  "intimate hang_standout piece_mirror_minimalist_hazy": [
    "flower",
    "loved",
    "panton",
    "rise",
    "108",
    "bloomlight",
    "remember",
    "sunup"
  ],
  "intimate hang_standout piece_mirror_mid-century modern_dark": [
    "bloomdark",
    "panton",
    "rain",
    "unique",
    "stump",
    "cool",
    "track",
    "dream"
  ],
  "intimate hang_standout piece_mirror_mid-century modern_neutral": [
    "108",
    "expo",
    "mule",
    "rise",
    "moment",
    "bloomlight",
    "idea",
    "warum"
  ],
    "intimate hang_standout piece_mirror_mid-century modern_simple": [
    "108",
    "expo",
    "mule",
    "rise",
    "moment",
    "bloomlight",
    "idea",
    "warum"
  ],
  "intimate hang_standout piece_mirror_mid-century modern_bright": [
    "trapped",
    "peace",
    "soul",
    "over",
    "loved",
    "work",
    "lately",
    "radiant"
  ],
  "intimate hang_standout piece_mirror_mid-century modern_hazy": [
    "soul",
    "search",
    "expo",
    "united",
    "club",
    "loved",
    "sheriff",
    "room"
  ],
  "intimate hang_standout piece_escape_bohemian_dark": [
    "dream",
    "bloomdark",
    "rain",
    "panton",
    "room",
    "floral",
    "remember",
    "wins"
  ],
  "intimate hang_standout piece_escape_bohemian_neutral": [
    "aenf",
    "veil",
    "bloomlight",
    "remember",
    "loved",
    "108",
    "window",
    "staytwo"
  ],
  "intimate hang_standout piece_escape_bohemian_simple": [
    "aenf",
    "veil",
    "bloomlight",
    "remember",
    "loved",
    "108",
    "window",
    "staytwo"
  ],
  "intimate hang_standout piece_escape_bohemian_bright": [
    "cogs",
    "rise",
    "soul",
    "club",
    "trapped",
    "stayone",
    "floral",
    "mule"
  ],
  "intimate hang_standout piece_escape_bohemian_hazy": [
    "loved",
    "rise",
    "bloomlight",
    "moment",
    "floral",
    "lies",
    "sunup",
    "work"
  ],
  "intimate hang_standout piece_escape_eclectic_dark": [
    "fear",
    "radiant",
    "trigger",
    "room",
    "void",
    "dirty",
    "warum",
    "panton"
  ],
  "intimate hang_standout piece_escape_eclectic_neutral": [
    "rise",
    "veil",
    "idea",
    "expo",
    "qualm",
    "sunup",
    "dozzy",
    "bloomlight"
  ],
  "intimate hang_standout piece_escape_eclectic_simple": [
    "rise",
    "veil",
    "idea",
    "expo",
    "qualm",
    "sunup",
    "dozzy",
    "bloomlight"
  ],
  "intimate hang_standout piece_escape_eclectic_bright": [
    "dirty",
    "bloomlight",
    "rise",
    "radiant",
    "qualm",
    "trapped",
    "lies",
    "soul"
  ],
  "intimate hang_standout piece_escape_eclectic_hazy": [
    "tour",
    "fuji",
    "rise",
    "loved",
    "sunup",
    "moment",
    "aenf",
    "search"
  ],
  "intimate hang_standout piece_escape_minimalist_dark": [
    "bloomdark",
    "dream",
    "qualm",
    "stayone",
    "load",
    "moment",
    "aenf",
    "warum"
  ],
  "intimate hang_standout piece_escape_minimalist_neutral": [
    "aenf",
    "moment",
    "panton",
    "expo",
    "bloomlight",
    "loved",
    "sunup",
    "mule"
  ],
  "intimate hang_standout piece_escape_minimalist_simple": [
    "aenf",
    "moment",
    "panton",
    "expo",
    "bloomlight",
    "loved",
    "sunup",
    "mule"
  ],
  "intimate hang_standout piece_escape_minimalist_bright": [
    "sunup",
    "soul",
    "search",
    "rise",
    "moment",
    "bloomlight",
    "dozzy",
    "work"
  ],
  "intimate hang_standout piece_escape_minimalist_hazy": [
    "bloomdark",
    "bloomlight",
    "moment",
    "sunup",
    "remember",
    "loved",
    "staytwo",
    "club"
  ],
  "intimate hang_standout piece_escape_mid-century modern_dark": [
    "panton",
    "bloomdark",
    "envy",
    "loved",
    "108",
    "rain",
    "dream",
    "kyoto"
  ],
  "intimate hang_standout piece_escape_mid-century modern_neutral": [
    "bloomlight",
    "sheriff",
    "expo",
    "flower",
    "rise",
    "idea",
    "remember",
    "wins"
  ],
  "intimate hang_standout piece_escape_mid-century modern_simple": [
    "bloomlight",
    "sheriff",
    "expo",
    "flower",
    "rise",
    "idea",
    "remember",
    "wins"
  ],
  "intimate hang_standout piece_escape_mid-century modern_bright": [
    "trapped",
    "rise",
    "loved",
    "floral",
    "bloomlight",
    "sunup",
    "work",
    "club"
  ],
  "intimate hang_standout piece_escape_mid-century modern_hazy": [
    "veil",
    "expo",
    "moment",
    "lately",
    "warum",
    "bloomlight",
    "rise",
    "floral"
  ],
  "intimate hang_seamless vibe_mirror_bohemian_dark": [
    "stump",
    "bloomdark",
    "stayone",
    "dream",
    "panton",
    "track",
    "room",
    "void"
  ],
  "intimate hang_seamless vibe_mirror_bohemian_neutral": [
    "aenf",
    "bloomdark",
    "trapped",
    "expo",
    "wins",
    "moment",
    "rise",
    "rain"
  ],
  "intimate hang_seamless vibe_mirror_bohemian_simple": [
    "aenf",
    "bloomdark",
    "trapped",
    "expo",
    "wins",
    "moment",
    "rise",
    "rain"
  ],
  "intimate hang_seamless vibe_mirror_bohemian_bright": [
    "veil",
    "rise",
    "sunup",
    "bloomlight",
    "cogs",
    "soul",
    "lies",
    "dozzy"
  ],
  "intimate hang_seamless vibe_mirror_bohemian_hazy": [
    "veil",
    "rise",
    "loved",
    "work",
    "bloomlight",
    "qualm",
    "radiant",
    "idea"
  ],
  "intimate hang_seamless vibe_mirror_eclectic_dark": [
    "dirty",
    "bloomdark",
    "fear",
    "void",
    "remember",
    "tour",
    "objekt",
    "qualm"
  ],
  "intimate hang_seamless vibe_mirror_eclectic_neutral": [
    "rise",
    "veil",
    "expo",
    "idea",
    "loved",
    "work",
    "bunk",
    "rave"
  ],
  "intimate hang_seamless vibe_mirror_eclectic_simple": [
    "rise",
    "veil",
    "expo",
    "idea",
    "loved",
    "work",
    "bunk",
    "rave"
  ],
  "intimate hang_seamless vibe_mirror_eclectic_bright": [
    "mule",
    "sunup",
    "rave",
    "expo",
    "cogs",
    "soul",
    "bunk",
    "wins"
  ],
  "intimate hang_seamless vibe_mirror_eclectic_hazy": [
    "work",
    "mule",
    "rise",
    "bloomlight",
    "radiant",
    "disco",
    "moment",
    "wins"
  ],
  "intimate hang_seamless vibe_mirror_minimalist_dark": [
    "bloomdark",
    "dream",
    "dozzy",
    "warum",
    "staytwo",
    "rise",
    "aenf",
    "club"
  ],
  "intimate hang_seamless vibe_mirror_minimalist_neutral": [
    "sad",
    "times",
    "dozzy",
    "warum",
    "rise",
    "bloomlight",
    "tour",
    "sunup"
  ],
  "intimate hang_seamless vibe_mirror_minimalist_simple": [
    "sad",
    "times",
    "dozzy",
    "warum",
    "rise",
    "bloomlight",
    "tour",
    "sunup"
  ],
  "intimate hang_seamless vibe_mirror_minimalist_bright": [
    "bunk",
    "mule",
    "times",
    "loved",
    "floral",
    "soul",
    "spiked",
    "expo"
  ],
  "intimate hang_seamless vibe_mirror_minimalist_hazy": [
    "expo",
    "spiked",
    "times",
    "cogs",
    "bloomlight",
    "rise",
    "dozzy",
    "hypno"
  ],
  "intimate hang_seamless vibe_mirror_mid-century modern_dark": [
    "tour ",
    "warum",
    "bloomdark",
    "bloomlight",
    "moment",
    "108",
    "aenf",
    "rave"
  ],
  "intimate hang_seamless vibe_mirror_mid-century modern_neutral": [
    "moment",
    "times",
    "trapped",
    "loved",
    "bloomlight",
    "rise",
    "wins",
    "sad"
  ],
  "intimate hang_seamless vibe_mirror_mid-century modern_simple": [
    "moment",
    "times",
    "trapped",
    "loved",
    "bloomlight",
    "rise",
    "wins",
    "sad"
  ],
  "intimate hang_seamless vibe_mirror_mid-century modern_bright": [
    "expo",
    "fear",
    "floral",
    "idea",
    "rise",
    "disco",
    "dozzy",
    "lies"
  ],
  "intimate hang_seamless vibe_mirror_mid-century modern_hazy": [
    "sunup",
    "qualm",
    "bloomdark",
    "remember",
    "trapped",
    "expo",
    "wins",
    "soul"
  ],
  "intimate hang_seamless vibe_escape_bohemian_dark": [
    "stump",
    "warum",
    "bloomdark",
    "panton",
    "soul",
    "disco",
    "oxford",
    "water"
  ],
  "intimate hang_seamless vibe_escape_bohemian_neutral": [
    "mule",
    "stump",
    "oxford",
    "rise",
    "loved",
    "expo",
    "dozzy",
    "moment"
  ],
  "intimate hang_seamless vibe_escape_bohemian_simple": [
    "mule",
    "stump",
    "oxford",
    "rise",
    "loved",
    "expo",
    "dozzy",
    "moment"
  ],
  "intimate hang_seamless vibe_escape_bohemian_bright": [
    "rise",
    "soul",
    "cogs",
    "qualm",
    "work",
    "sheriff",
    "peace",
    "loved"
  ],
  "intimate hang_seamless vibe_escape_bohemian_hazy": [
    "moment",
    "veil",
    "bloomdark",
    "disco",
    "wins",
    "dvs1",
    "rave",
    "trapped"
  ],
  "intimate hang_seamless vibe_escape_eclectic_dark": [
    "bloomdark",
    "rave",
    "dvs1",
    "tour",
    "oxford",
    "disco",
    "fuji",
    "brain"
  ],
  "intimate hang_seamless vibe_escape_eclectic_neutral": [
    "work",
    "brain",
    "fuji",
    "rise",
    "loved",
    "bloomlight",
    "dozzy",
    "sad"
  ],
  "intimate hang_seamless vibe_escape_eclectic_simple": [
    "work",
    "brain",
    "fuji",
    "rise",
    "loved",
    "bloomlight",
    "dozzy",
    "sad"
  ],
  "intimate hang_seamless vibe_escape_eclectic_bright": [
    "work",
    "fear",
    "lies",
    "floral",
    "replay",
    "cogs",
    "soul",
    "radiant"
  ],
  "intimate hang_seamless vibe_escape_eclectic_hazy": [
    "work",
    "mule",
    "rise",
    "bloomlight",
    "radiant",
    "disco",
    "moment",
    "sad"
  ],
  "intimate hang_seamless vibe_escape_minimalist_dark": [
    "bloomdark",
    "oxford",
    "dozzy",
    "disco",
    "staytwo",
    "rise",
    "aenf",
    "club"
  ],
  "intimate hang_seamless vibe_escape_minimalist_neutral": [
    "sad",
    "times",
    "replay",
    "warum",
    "rise",
    "bloomlight",
    "tour",
    "oxford"
  ],
  "intimate hang_seamless vibe_escape_minimalist_simple": [
    "sad",
    "times",
    "replay",
    "warum",
    "rise",
    "bloomlight",
    "tour",
    "oxford"
  ],
  "intimate hang_seamless vibe_escape_minimalist_bright": [
    "bunk",
    "mule",
    "odyssey",
    "loved",
    "floral",
    "soul",
    "spiked",
    "expo"
  ],
  "intimate hang_seamless vibe_mid-century modern_hazy": [
    "expo",
    "spiked",
    "times",
    "oxford",
    "bloomlight",
    "soul",
    "dozzy",
    "hypno"
  ],
  "intimate hang_seamless vibe_escape_mid-century modern_dark": [
    "oxford",
    "warum",
    "bloomdark",
    "bloomlight",
    "moment",
    "108",
    "disco",
    "rave"
  ],
  "intimate hang_seamless vibe_escape_mid-century modern_neutral": [
    "moment",
    "disco",
    "expo",
    "loved",
    "bloomlight",
    "rise",
    "wins",
    "sad"
  ],
  "intimate hang_seamless vibe_escape_mid-century modern_simple": [
    "moment",
    "disco",
    "expo",
    "loved",
    "bloomlight",
    "rise",
    "wins",
    "sad"
  ],
  "intimate hang_seamless vibe_escape_mid-century modern_bright": [
    "trapped",
    "rise",
    "loved",
    "floral",
    "bloomlight",
    "sunup",
    "work",
    "sad"
  ],
  "intimate hang_seamless vibe_escape_mid-century modern_hazy": [
    "sunup",
    "qualm",
    "bloomdark",
    "floral",
    "disco",
    "expo",
    "wins",
    "soul"
  ],
  "full house_standout piece_mirror_bohemian_dark": [
    "bloomdark",
    "rave",
    "qualm",
    "objekt",
    "oxford",
    "disco",
    "flower",
    "brain"
  ],
  "full house_standout piece_mirror_bohemian_neutral": [
    "mule",
    "rave",
    "brain",
    "rise",
    "loved",
    "expo",
    "dozzy",
    "oxford"
  ],
  "full house_standout piece_mirror_bohemian_simple": [
    "mule",
    "rave",
    "brain",
    "rise",
    "loved",
    "expo",
    "dozzy",
    "oxford"
  ],
  "full house_standout piece_mirror_bohemian_bright": [
    "rise",
    "soul",
    "cogs",
    "sunup",
    "brain",
    "sheriff",
    "wins",
    "loved"
  ],
  "full house_standout piece_mirror_bohemian_hazy": [
    "dozzy",
    "veil",
    "bloomdark",
    "disco",
    "wins",
    "dvs1",
    "rave",
    "trapped"
  ],
  "full house_standout piece_mirror_eclectic_dark": [
    "bloomdark",
    "rave",
    "dvs1",
    "objekt",
    "oxford",
    "void",
    "fuji",
    "brain"
  ],
  "full house_standout piece_mirror_eclectic_neutral": [
    "rise",
    "sad",
    "expo",
    "bloomlight",
    "loved",
    "work",
    "bunk",
    "odyssey"
  ],
  "full house_standout piece_mirror_eclectic_simple": [
    "rise",
    "sad",
    "expo",
    "bloomlight",
    "loved",
    "work",
    "bunk",
    "odyssey"
  ],
  "full house_standout piece_mirror_eclectic_bright": [
    "dirty",
    "bloomlight",
    "rise",
    "radiant",
    "odyssey",
    "trapped",
    "floral",
    "cogs"
  ],
  "full house_standout piece_mirror_eclectic_hazy": [
    "disco",
    "fuji",
    "rise",
    "loved",
    "soul",
    "moment",
    "floral",
    "bloomlight"
  ],
  "full house_standout piece_mirror_minimalist_dark": [
    "bloomdark",
    "loved",
    "kyoto",
    "bloomlight",
    "water",
    "moment",
    "aenf",
    "panton"
  ],
  "full house_standout piece_mirror_minimalist_neutral": [
    "kyoto",
    "loved",
    "rise",
    "bloomlight",
    "brain",
    "wins",
    "108",
    "work"
  ],
  "full house_standout piece_mirror_minimalist_simple": [
    "kyoto",
    "loved",
    "rise",
    "bloomlight",
    "brain",
    "wins",
    "108",
    "work"
  ],
  "full house_standout piece_mirror_minimalist_bright": [
    "bunk",
    "108",
    "odyssey",
    "loved",
    "bloomlight",
    "soul",
    "spiked",
    "expo"
  ],
  "full house_standout piece_mirror_minimalist_hazy": [
    "expo",
    "spiked",
    "odyssey",
    "cogs",
    "bloomdark",
    "rise",
    "search",
    "hypno"
  ],
  "full house_standout piece_mirror_mid-century modern_dark": [
    "hypno",
    "warum",
    "bloomdark",
    "fuji",
    "oxford",
    "108",
    "aenf",
    "rave"
  ],
  "full house_standout piece_mirror_mid-century modern_neutral": [
    "108",
    "expo",
    "odyssey",
    "rise",
    "disco",
    "bloomlight",
    "spiked",
    "warum"
  ],
  "full house_standout piece_mirror_mid-century modern_simple": [
    "108",
    "expo",
    "odyssey",
    "rise",
    "disco",
    "bloomlight",
    "spiked",
    "warum"
  ],
  "full house_standout piece_mirror_mid-century modern_bright": [
    "trapped",
    "odyssey",
    "soul",
    "bloomlight",
    "loved",
    "brain",
    "lately",
    "rise"
  ],
  "full house_standout piece_mirror_mid-century modern_hazy": [
    "cogs",
    "search",
    "expo",
    "disco",
    "wins",
    "loved",
    "sheriff",
    "hypno"
  ],
  "full house_standout piece_escape_bohemian_dark": [
    "stump",
    "bloomdark",
    "stayone",
    "dream",
    "panton",
    "track",
    "room",
    "void"
  ],
  "full house_standout piece_escape_bohemian_neutral": [
    "aenf",
    "panton",
    "kyoto",
    "loved",
    "odyssey",
    "warum",
    "rise",
    "hypno"
  ],
  "full house_standout piece_escape_bohemian_simple": [
    "aenf",
    "panton",
    "kyoto",
    "loved",
    "odyssey",
    "warum",
    "rise",
    "hypno"
  ],
  "full house_standout piece_escape_bohemian_bright": [
    "rise",
    "soul",
    "replay",
    "sunup",
    "work",
    "sheriff",
    "brain",
    "loved"
  ],
  "full house_standout piece_escape_bohemian_hazy": [
    "rise",
    "bloomdark",
    "trapped",
    "108",
    "remember",
    "rain",
    "veil",
    "remember"
  ],
  "full house_standout piece_escape_eclectic_dark": [
    "replay",
    "rave",
    "dvs1",
    "objekt",
    "disco",
    "void",
    "fuji",
    "brain"
  ],
  "full house_standout piece_escape_eclectic_neutral": [
    "replay",
    "veil",
    "expo",
    "objekt",
    "loved",
    "work",
    "brain",
    "rave"
  ],
  "full house_standout piece_escape_eclectic_simple": [
    "replay",
    "veil",
    "expo",
    "objekt",
    "loved",
    "work",
    "brain",
    "rave"
  ],
  "full house_standout piece_escape_eclectic_bright": [
    "soul",
    "cogs",
    "peace",
    "trapped",
    "lies",
    "radiant",
    "search",
    "envy"
  ],
  "full house_standout piece_escape_eclectic_hazy": [
    "disco",
    "odyssey",
    "rise",
    "loved",
    "soul",
    "work",
    "floral",
    "disco"
  ],
  "full house_standout piece_escape_minimalist_dark": [
    "bloomdark",
    "loved",
    "kyoto",
    "rave",
    "water",
    "moment",
    "search",
    "panton"
  ],
  "full house_standout piece_escape_minimalist_neutral": [
    "aenf",
    "odyssey",
    "rise",
    "bloomlight",
    "work",
    "wins",
    "108",
    "work"
  ],
  "full house_standout piece_escape_minimalist_simple": [
    "aenf",
    "odyssey",
    "rise",
    "bloomlight",
    "work",
    "wins",
    "108",
    "work"
  ],
  "full house_standout piece_escape_minimalist_bright": [
    "odyssey",
    "soul",
    "search",
    "sunup",
    "brain",
    "bloomlight",
    "dozzy",
    "veil"
  ],
  "full house_standout piece_escape_minimalist_hazy": [
    "expo",
    "spiked",
    "replay",
    "oxford",
    "work",
    "soul",
    "veil",
    "hypno"
  ],
  "full house_standout piece_escape_mid-century modern_dark": [
    "trapped",
    "warum",
    "bloomdark",
    "dvs1",
    "disco",
    "108",
    "aenf",
    "rave"
  ],
  "full house_standout piece_escape_mid-century modern_neutral": [
    "fuji",
    "disco",
    "expo",
    "loved",
    "bloomlight",
    "rise",
    "floral",
    "hypno"
  ],
  "full house_standout piece_escape_mid-century modern_simple": [
    "fuji",
    "disco",
    "expo",
    "loved",
    "bloomlight",
    "rise",
    "floral",
    "hypno"
  ],
  "full house_standout piece_escape_mid-century modern_bright": [
    "trapped",
    "rise",
    "loved",
    "fuji",
    "bloomlight",
    "replay",
    "work",
    "club"
  ],
  "full house_standout piece_escape_mid-century modern_hazy": [
    "soul",
    "search",
    "work",
    "bloomlight",
    "club",
    "radiant",
    "sheriff",
    "envy"
  ],
  "full house_seamless vibe_mirror_bohemian_dark": [
    "aenf",
    "rave",
    "dvs1",
    "objekt",
    "disco",
    "void",
    "fuji",
    "idea"
  ],
  "full house_seamless vibe_mirror_bohemian_neutral": [
    "soul",
    "odyssey",
    "veil",
    "expo",
    "wins",
    "moment",
    "rise",
    "rain"
  ],
  "full house_seamless vibe_mirror_bohemian_simple": [
    "soul",
    "odyssey",
    "veil",
    "expo",
    "wins",
    "moment",
    "rise",
    "rain"
  ],
  "full house_seamless vibe_mirror_bohemian_bright": [
    "rise",
    "soul",
    "expo",
    "sunup",
    "work",
    "bunk",
    "floral",
    "loved"
  ],
  "full house_seamless vibe_mirror_bohemian_hazy": [
    "rise",
    "bloomdark",
    "trapped",
    "dream",
    "warum",
    "rain",
    "odyssey",
    "loved"
  ],
  "full house_seamless vibe_mirror_eclectic_dark": [
    "replay",
    "rave",
    "cool",
    "objekt",
    "disco",
    "radiant",
    "fuji",
    "work"
  ],
  "full house_seamless vibe_mirror_eclectic_neutral": [
    "soul",
    "spiked",
    "track",
    "ocho",
    "staytwo",
    "loved",
    "108",
    "floral"
  ],
  "full house_seamless vibe_mirror_eclectic_simple": [
    "soul",
    "spiked",
    "track",
    "ocho",
    "staytwo",
    "loved",
    "108",
    "floral"
  ],
  "full house_seamless vibe_mirror_eclectic_bright": [
    "mutar",
    "look",
    "spiked",
    "cogs",
    "trapped",
    "search",
    "hypno",
    "dozzy"
  ],
  "full house_seamless vibe_mirror_eclectic_hazy": [
    "every",
    "look",
    "wins",
    "disco",
    "warum",
    "work",
    "over",
    "cool"
  ],
  "full house_seamless vibe_mirror_minimalist_dark": [
    "mutar",
    "oxford",
    "dozzy",
    "disco",
    "staytwo",
    "rise",
    "every",
    "cool"
  ],
  "full house_seamless vibe_mirror_minimalist_neutral": [
    "look",
    "odyssey",
    "rise",
    "bloomlight",
    "brain",
    "sad",
    "108",
    "warum"
  ],
  "full house_seamless vibe_mirror_minimalist_simple": [
    "look",
    "odyssey",
    "rise",
    "bloomlight",
    "brain",
    "sad",
    "108",
    "warum"
  ],
  "full house_seamless vibe_mirror_minimalist_bright": [
    "look",
    "soul",
    "search",
    "replay",
    "work",
    "rise",
    "dozzy",
    "trapped"
  ],
  "full house_seamless vibe_mirror_minimalist_hazy": [
    "every",
    "spiked",
    "cool",
    "disco",
    "lies",
    "sad",
    "kyoto",
    "hypno"
  ],
  "full house_seamless vibe_mirror_mid-century modern_dark": [
    "ocho",
    "loved",
    "kyoto",
    "rave",
    "mutar",
    "track",
    "fuji",
    "panton"
  ],
  "full house_seamless vibe_mirror_mid-century modern_neutral": [
    "rave",
    "oxford",
    "expo",
    "look",
    "soul",
    "wins",
    "floral",
    "hypno"
  ],
  "full house_seamless vibe_mirror_mid-century modern_simple": [
    "rave",
    "oxford",
    "expo",
    "look",
    "soul",
    "wins",
    "floral",
    "hypno"
  ],
  "full house_seamless vibe_mirror_mid-century modern_bright": [
    "trapped",
    "odyssey",
    "soul",
    "sunup",
    "loved",
    "work",
    "lately",
    "rain"
  ],
  "full house_seamless vibe_mirror_mid-century modern_hazy": [
    "soul",
    "search",
    "expo",
    "remeber",
    "club",
    "loved",
    "sheriff",
    "peace"
  ],
  "full house_seamless vibe_escape_bohemian_dark": [
    "stump",
    "warum",
    "cool",
    "expo",
    "soul",
    "loved",
    "oxford",
    "ocho"
  ],
  "full house_seamless vibe_escape_bohemian_neutral": [
    "every",
    "work",
    "trapped",
    "expo",
    "sad",
    "remember",
    "rise",
    "kyoto"
  ],
  "full house_seamless vibe_escape_bohemian_simple": [
    "every",
    "work",
    "trapped",
    "expo",
    "sad",
    "remember",
    "rise",
    "kyoto"
  ],
  "full house_seamless vibe_escape_bohemian_bright": [
    "dopa",
    "work",
    "sunup",
    "lately",
    "wins",
    "rise",
    "rain",
    "bloomlight"
  ],
  "full house_seamless vibe_escape_bohemian_hazy": [
    "dopa",
    "oxford",
    "trapped",
    "wins",
    "cogs",
    "loved",
    "bloomlight",
    "hypno"
  ],
  "full house_seamless vibe_escape_eclectic_dark": [
    "panton",
    "bloomdark",
    "dream",
    "qualm",
    "stayone",
    "load",
    "moment",
    "aenf"
  ],
  "full house_seamless vibe_escape_eclectic_neutral": [
    "soul",
    "rise",
    "veil",
    "idea",
    "expo",
    "hypno",
    "sunup",
    "work"
  ],
  "full house_seamless vibe_escape_eclectic_simple": [
    "soul",
    "rise",
    "veil",
    "idea",
    "expo",
    "hypno",
    "sunup",
    "work"
  ],
  "full house_seamless vibe_escape_eclectic_bright": [
    "dopa",
    "oxford",
    "rain",
    "kyoto",
    "soul",
    "cogs",
    "sheriff",
    "brain"
  ],
  "full house_seamless vibe_escape_eclectic_hazy": [
    "dopa",
    "disco",
    "trapped",
    "ocho",
    "mule",
    "rise",
    "bloomlight",
    "radiant"
  ],
  "full house_seamless vibe_escape_minimalist_dark": [
    "panton",
    "dream",
    "dozzy",
    "warum",
    "stayone",
    "rise",
    "aenf",
    "club"
  ],
  "full house_seamless vibe_escape_minimalist_neutral": [
    "qualm",
    "times",
    "dozzy",
    "warum",
    "rise",
    "bloomlight",
    "tour",
    "sunup"
  ],
  "full house_seamless vibe_escape_minimalist_simple": [
    "qualm",
    "times",
    "dozzy",
    "warum",
    "rise",
    "bloomlight",
    "tour",
    "sunup"
  ],
  "full house_seamless vibe_escape_minimalist_bright": [
    "dopa",
    "disco",
    "rain",
    "wins",
    "floral",
    "soul",
    "spiked",
    "expo"
  ],
  "full house_seamless vibe_escape_minimalist_hazy": [
    "dopa",
    "oxford",
    "trapped",
    "kyoto",
    "club",
    "loved",
    "sheriff",
    "room"
  ],
  "full house_seamless vibe_escape_mid-century modern_dark": [
    "brain",
    "stayone",
    "panton",
    "rain",
    "soul",
    "bloomdark",
    "loved",
    "cool"
  ],
  "full house_seamless vibe_escape_mid-century modern_neutral": [
    "work",
    "odyssey",
    "veil",
    "expo",
    "wins",
    "moment",
    "rise",
    "rain"
  ],
  "full house_seamless vibe_escape_mid-century modern_simple": [
    "work",
    "odyssey",
    "veil",
    "expo",
    "wins",
    "moment",
    "rise",
    "rain"
  ],
  "full house_seamless vibe_escape_mid-century modern_bright": [
    "dopa",
    "oxford",
    "rain",
    "ocho",
    "replay",
    "cogs",
    "soul",
    "radiant"
  ],
  "full house_seamless vibe_escape_mid-century modern_hazy": [
    "dopa",
    "disco",
    "trapped",
    "objekt",
    "remember",
    "rain",
    "veil",
    "soul"
  ]
};

export default curatedMap;